var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderr"},[_c('div',{staticClass:"sub"},[_c('span',[_vm._v(_vm._s(_vm.loadErrText))]),_vm._v(" "),_c('p',{staticClass:"cursor",on:{"click":_vm.loadvideo}},[_vm._v(_vm._s(_vm.streamList.length > 0 ? '切换线路' : '点击重试'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f68d14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/video/loaderr.vue
// module id = null
// module chunks = 